import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import {
  isKsDefinitifPlt,
  isUserHasRole,
} from 'app/KinerjaKSPage/utils/profile'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import {
  PENGELOLAAN_KINERJA_GURU_PATH,
  PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
} from 'app/KinerjaShared/constants/path'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { formatPeriod } from 'app/KinerjaShared/utils/period'

import type {
  ActivityType,
  ScreenName,
} from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'

export default function usePageHeader() {
  const router = useRouter()
  const { trackEvent } = useSKPPelaksanaanTrackEvent()

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

  const { profile: dataProfile } = useRoleContext()

  const {
    period,
    isHavePeriod,
    isEnabled: isMultiplePeriodEnabled,
    periodNo,
  } = usePeriodContext()

  // Tracker
  useEffect(() => {
    if (isMenuOpen && dataProfile) {
      let activityType: ActivityType = null
      let screenName: ScreenName = null

      // ks tracker
      if (isKsDefinitifPlt(dataProfile)) {
        activityType = 'pelaksanaan_click_navigation_profile'
        const ptkId = router?.query?.ptkId
        const npsn = router?.query?.npsn

        switch (router?.asPath) {
          case PENGELOLAAN_KINERJA_KS_PENILAI_PATH:
            screenName = 'homepage_penilaian_ks'
            break
          case `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/${npsn}`:
            screenName = 'pelaksanaan_hub_ks'
            break
          case `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/pelaksanaan/dokumen-penilaian-observasi/${ptkId}`:
            screenName = 'form_b_ks'
            break
          case `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/pelaksanaan/dokumen-tindak-lanjut/${ptkId}`:
            screenName = 'form_c_ks'
            break
          case `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/pelaksanaan/dokumen-refleksi-tindak-lanjut/${ptkId}`:
            screenName = 'form_d_ks'
            break
        }
      }
      // guru tracker
      if (isUserHasRole(dataProfile, 'GURU')) {
        activityType = 'pelaksanaan_click_navigation_profile'
        switch (router?.asPath) {
          case PENGELOLAAN_KINERJA_GURU_PATH:
            screenName = 'homepage_pengelolaan'
            break
          case `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/beranda`:
            screenName = 'pelaksanaan_hub'
            break
          case `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-persiapan`:
            screenName = 'form_a'
            break
          case `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/rincian-observasi`:
            screenName = 'form_b'
            break
          case `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-tindak-lanjut`:
          case `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-tindak-lanjut/detail`:
            screenName = 'form_c'
            break
          case `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-refleksi-tindak-lanjut`:
            screenName = 'form_d'
            break
          default:
            activityType = null
            break
        }
      }
      if (activityType && screenName) {
        trackEvent({
          activity_type: activityType,
          screen_name: screenName,
          event_trigger: screenName,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuOpen, dataProfile])

  return {
    isMenuOpen,
    setIsMenuOpen,
    isMultiplePeriodEnabled,
    formattedPeriod: isHavePeriod
      ? formatPeriod(period.startDate, period.endDate)
      : '',
    isHavePeriod,
    periodNumber: periodNo,
  }
}
